module.exports = __webpack_public_path__ + "static/media/n_icon_jiaoyimingxi.a2571de5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_jiaoyimingxi.png
// module id = 670
// module chunks = 0 1